import { Locale } from '../clients/CacheClient'
import { useLocales } from '../state'

export const formatNumber = (
  number: any,
  unit?: string,
  formatOptions?: Intl.NumberFormatOptions
) => {
  if (typeof number !== 'number') return

  let options: Intl.NumberFormatOptions
  if (Math.abs(number) < 0.001) {
    options = {
      minimumSignificantDigits: 1,
      maximumSignificantDigits: 2,
      roundingMode: 'halfTrunc',
      useGrouping: false,
      ...formatOptions,
    }
  } else {
    options = {
      maximumFractionDigits: 4,
      roundingMode: 'halfTrunc',
      useGrouping: false,
      notation: number >= 100000 ? 'compact' : 'standard',
      ...formatOptions,
    }
  }

  const result = Intl.NumberFormat('en-GB', options).format(number)

  if (unit) {
    return `${result}${unit === '%' ? '' : ' '}${unit}`
  } else {
    return result
  }
}

export const formatMoney = (
  usdAmount: any,
  locale?: Locale,
  formatOptions?: Intl.NumberFormatOptions & { format?: 'precise' }
) => {
  if (typeof usdAmount !== 'number') return

  if (!locale) {
    locale = useLocales.getState().userLocale
  }

  const { format, ...overrides } = formatOptions || {}

  let options: Intl.NumberFormatOptions = {
    currency: locale.currency.code,
    style: 'currency',
    currencyDisplay: 'narrowSymbol',
    minimumFractionDigits: 2,
    ...overrides,
  }

  if (format === 'precise' && usdAmount < 0.01) {
    options.minimumSignificantDigits = 1
    options.maximumSignificantDigits = 2
  }

  const userCurrencyAmount = usdAmount * locale.currency.usdExchangeRate

  return Intl.NumberFormat(locale.numberFormat, options).format(userCurrencyAmount)
}
